import React, { useEffect, useState, useCallback, useRef } from "react";
import { useLocation } from "react-router-dom";
import LandingOTP from "../components/LandingOTP";
// @ts-ignore
import ApiNames from "../constants/ApiNames";
// @ts-ignore
import { loginSendOtp, sendOtp } from "../services/AuthService";
import { apiClient } from "../services/NetworkService";
// @ts-ignore
import tagManagerEvents from "../utils/GoogleTagManager";
// @ts-ignore
import { setCookie } from "../utils/CommonFunction";

export interface LandingOTPScreenProps {
  token?: string;
  loaderStatus: (status: boolean) => void;
}

const LandingOTPScreen: React.FC<LandingOTPScreenProps> = (props) => {
  const { state } = useLocation() as any;

  const [utm_source, setUtm_source] = useState<string>("");
  const parameters = state?.parameters || "";
  
  const [phNumber, setphNumber] = useState<string>("");
  const [miniLoading, setMiniLoading] = useState<boolean>(false);
  const [error, setError] = useState<{ Error: string; isTrue: boolean }>({ Error: "", isTrue: false });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [, setLoader] = useState<boolean>(false);
  const [otp, setOtp] = useState<string[]>(["", "", "", ""]);
  const [timer, setTimer] = useState<number>(30);

  const uuidRef = useRef<string>("");

  useEffect(() => {
    document.title = "pin";

    if (!state) {
      window.location.replace(window.location.origin + "/landing");
    } else {
      uuidRef.current = state.uuid || "";
      if (state.HeFlag) {
        const updatedOtp = state.HeFlag.split("");
        setOtp(updatedOtp);
      }
      console.warn("these are states", state);
      props.loaderStatus(true);
      setphNumber(state.msisdn || "");
      setUtm_source(state.utm_source || "");
      
      if (state.otp) {
        setOtp([...state.otp]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (timer > 0) {
      interval = setTimeout(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    return () => clearTimeout(interval);
  }, [timer]);

  const onChangeOtp = useCallback((value: string, index: number) => {
    setError({
      Error: "",
      isTrue: false,
    });
    setMiniLoading(false);
    
    setOtp((prevOtp) => {
      const newOtp = [...prevOtp];
      if (index === 0) {
        if (value.length === 4) {
          return value.split("");
        } else if (value.length === 1) {
          return [value, "", "", ""];
        } else {
          return ["", "", "", ""];
        }
      } else {
        newOtp[index] = value;
        return newOtp;
      }
    });
  }, []);

  const sendWebOtp = useCallback(async (num: string) => {
    try {
      let response: any;
      if (state?.isUserActive) {
        response = await loginSendOtp(num, props.token);
      } else {
        response = await sendOtp(num, props.token);
      }
      console.warn("this is subscrube", response);
      if (response && response.status === 200) {
        tagManagerEvents("Request_OTP", utm_source);
        uuidRef.current = response.response?.uuid || "";
        if (state?.HeFlag) {
          const updatedOtp = (response.response?.desc || "").split("");
          setOtp(updatedOtp);
        }
      } else {
        setError({
          Error: "Something went wrong, Please try again later",
          isTrue: true,
        });
        setMiniLoading(false);
      }
      setLoader(false);
    } catch (error) {
      console.warn("subscribe error ::", error);
      setLoader(false);
      setError({
        Error: "Something went wrong, Please try again later",
        isTrue: true,
      });
      setMiniLoading(false);
    }
  }, [state, props.token, utm_source]);

  const resendOtp = useCallback(async () => {
    try {
      setError({
        Error: "",
        isTrue: false,
      });
      setOtp(["", "", "", ""]);
      setMiniLoading(false);
      sendWebOtp(phNumber);
    } catch (error) {
      console.log("resend otp error ::", error);
    }
  }, [phNumber, sendWebOtp]);

  const subscribe = useCallback(async (currentOtp: string[]) => {
    try {
      setMiniLoading(true);
      const OTP = currentOtp.join("");
      const endpoint = `${ApiNames.subscribe}?msisdn=${parseInt(
        state?.msisdn || "0"
      )}&level_id=1&name=Guest&utm_source=${state?.utm_source || ""}&subPackage=${
        state?.userPackage || ""
      }&login=${state?.isUserActive || false}&otp=${OTP}&uuid=${uuidRef.current}`;
      
      const config = props.token ? { headers: { Authorization: `Bearer ${props.token}` } } : {};
      const res = await apiClient.post(endpoint, null, config);
      const response = res.data;

      if (response && response.status === 208) {
        console.log("response", response);
        tagManagerEvents("OTP_VERIFIED", utm_source);
        tagManagerEvents("subscribe", utm_source);
        let url = window.location.origin;
        setCookie(
          (response.response?.msisdn || "").slice(-10),
          response.response?.token,
          response.response?.subscribeId
        );
        
        url = `${url}/home`;
        if (url.includes("http:")) {
          url = url.replace("http", "https");
        }
        window.location.replace(url);
      } else if (response && response.status === 400) {
        setError({
          Error: "OTP is Invalid or Expired, Please subscribe again",
          isTrue: true,
        });
        setOtp(["", "", "", ""]);
        tagManagerEvents("OTP_FAILED", utm_source);
        setMiniLoading(false);
      } else {
        setError({
          Error: "Something went wrong, Please try again later",
          isTrue: true,
        });
        tagManagerEvents("Subcribe_Unsuccessful", utm_source);
        setMiniLoading(false);
      }
    } catch (error) {
      setMiniLoading(false);
      tagManagerEvents("Subcribe_Unsuccessful", utm_source);
      console.warn("subscribe error ", error);
    }
  }, [state, props.token, utm_source]);

  const handleResendOTP = useCallback(() => {
    setTimer(30);
  }, []);

  return (
    <LandingOTP
      msisdn={phNumber}
      subscribe={subscribe}
      error={error}
      otp={otp}
      onChangeOtp={onChangeOtp}
      resendOtp={resendOtp}
      miniLoading={miniLoading}
      timer={timer}
      handleResendOTP={handleResendOTP}
      parameters={parameters}
    />
  );
};

export default LandingOTPScreen;
